
// IMPORTANT: This file is auto generated! Do not manually edit or checkin!
// tslint:disable
export const GIT_INFO = {
  "dirty": true,
  "raw": "860fff3-dirty",
  "hash": "860fff3",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "860fff3-dirty",
  "semverString": null
};
